/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HierarchiesControllerGetMembersQueryResponse, HierarchiesControllerGetMembersPathParams, HierarchiesControllerGetMembersQueryParams, HierarchiesControllerGetMembers401, HierarchiesControllerGetMembers403 } from "../../models/hierarchiesController/HierarchiesControllerGetMembers";

function getHierarchiesControllerGetMembersUrl(scopeId: HierarchiesControllerGetMembersPathParams["scopeId"]) {
  const res = { method: 'GET', url: `/api/v1/hierarchies/${scopeId}/members` as const }  
  return res
}

/**
 * @description Retrieve all members (users) of a scope with membership metadata as extensions
 * @summary Get scope members
 * {@link /api/v1/hierarchies/:scopeId/members}
 */
export async function hierarchiesControllerGetMembers(scopeId: HierarchiesControllerGetMembersPathParams["scopeId"], params?: HierarchiesControllerGetMembersQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<HierarchiesControllerGetMembersQueryResponse, ResponseErrorConfig<HierarchiesControllerGetMembers401 | HierarchiesControllerGetMembers403>, unknown>({ method : "GET", url : getHierarchiesControllerGetMembersUrl(scopeId).url.toString(), params, ... requestConfig })  
  return res.data
}